<div class="toolbar justify-content-end">
  <button
    type="button"
    class="btn btn-light"
    [swal]="{
      title: 'Créer un tag',
      icon: 'info',
      text: 'Créer un nouveeau tag',
      showCancelButton: true,
      input: 'text',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Créer'
    }"
    (confirm)="createTag($event)"
  >
    <em class="fal fa-plus"></em> Nouveau tag
  </button>
</div>

@if (tags) {
@if (tags.length > 0) {
<ul class="card tag-list">
  @for (tag of tags; track tag) {
  <li class="tag-item">
    <a class="tag-item-name" (click)="showPeopleForTag(tag)">{{ tag.name }}</a>
    <div class="row-actions">
      <button
        type="button"
        class="btn btn-light btn-icon"
        tooltip="Renommer"
        [swal]="{
          title: 'Renommer le tag',
          icon: 'question',
          input: 'text',
          text: 'Renommer ' + tag.name,
          showCancelButton: true,
          cancelButtonText: 'Annuler',
          confirmButtonText: 'Renommer'
        }"
        (confirm)="renameTag(tag, $event)"
      >
        <em class="fal fa-pencil"></em>
      </button>
      <button
        type="button"
        class="btn btn-outline-danger btn-icon"
        tooltip="Supprimer"
        [swal]="{
          title: 'Supprimer le tag',
          icon: 'error',
          text: 'Supprimer ' + tag.name,
          showCancelButton: true,
          cancelButtonText: 'Annuler',
          confirmButtonText: 'Supprimer'
        }"
        (confirm)="removeTag(tag)"
      >
        <em class="fal fa-trash"></em>
      </button>
    </div>
  </li>
  }
</ul>
} @else {
<div class="empty-state">
  <div class="empty-state-icon"><em class="fal fa-tag"></em></div>
  <p class="empty-state-text">Aucun tag créé.</p>
</div>
}
}
